import React, {useEffect, useRef, useState} from "react";
import Banner from "../Banner/Banner";
import UsualQuestions from "../UsualQuestions/UsualQuestions";
import "./Homepage.css";
import Loader from "../Loader/Loader";
import ProductsService from "../../services/ProductsService";
import ProductCards from "./ProductCards/ProductCards";
import Devices from "./Devices/Devices";
import ProductTabs from "./ProductTabs/ProductTabs";
import Preview from "./Preview/Preview";
import {LandingPageHelper} from "../Utilities/CmsHelpers";
import {useLocation, useNavigate} from "react-router-dom";
import GenericError from "../Utilities/GenericError";
import PopUp from "../Utilities/PopUp";
import Markdown from "react-markdown";
import {useLoading} from "../../context/LoadingContext";
import {useCms} from "../../context/CmsContext";
import {useAuth} from "../../context/AuthContext";
import {useAccount} from "../../context/AccountContext";
import {useTranslation} from "react-i18next";
import Boxes from "./Boxes/Boxes";

function Homepage({goToProducts = false}) {
    const {t} = useTranslation()
    const location = useLocation();
    const account = useAccount();

    const navigate = useNavigate();

    const {isLoading, removeLoading, addLoading} = useLoading();
    const {loggedIn, authData} = useAuth();

    const [hasSubscription, setHasSubscription] = useState(false);
    // const [isLoading, setIsLoading] = useState(false);
    const [packageData, setPackageData] = useState();
    const [avod, setAvod] = useState(false);
    const [freeProduct, setFreeProduct] = useState(false);
    const [productName, setProductName] = useState("");

    const {landingData} = useCms();
    const contextLanding = landingData;
    const bannerDataList = LandingPageHelper.getBannerSection(contextLanding);

    const [informationModal, setInformationModal] = useState([]);
    const [showInformationModal, setShowInformationModal] = useState(false);

    const [genericError, setGenericError] = useState(false);

    useEffect(()=>{
        setInformationModal(LandingPageHelper.getInformationModal(contextLanding))
    }, [contextLanding])

    useEffect(()=>{
        setShowInformationModal((!!informationModal?.length))
    }, [informationModal])

    const searchParams = new URLSearchParams(location.search);
    const promo = searchParams.get('promo');
    const contest = searchParams.get('contest');
    const [bannerData, setBannerData] = useState({})

    useEffect(() => {
        if (bannerDataList && bannerDataList.length) {
            if(!!promo){
                var intresteadPromo = bannerDataList.find(item => item.__component === "ant1.promo-banner" && item.identifier === promo)
                if(!!intresteadPromo){
                    setBannerData(intresteadPromo)
                    return;
                }
            }

            if(!!contest){
                var intresteadContest = bannerDataList.find(item => item.__component === "ant1.contest-banner" && item.identifier === contest)
                if(!!intresteadContest){
                    setBannerData(intresteadContest)
                    return;
                }
            }

            var defaultBanners = bannerDataList.filter(item => (item.__component === "ant1.default-banner"));
            if(!!productName){
                var interesteadDefault = defaultBanners.find(item => item.display_names.data.find(disName => disName.attributes.value.toLowerCase() === productName.toLowerCase()))
                if(!!interesteadDefault){
                    setBannerData(interesteadDefault)
                }else{
                    setBannerData(defaultBanners.find(item => item.display_names.data.length === 0) ?? defaultBanners[0])
                }
                return;
            }else{
                setBannerData(defaultBanners.find(item => item.display_names.data.find(disName => disName.attributes.value.toLowerCase() === ("Generic").toLowerCase())) ?? defaultBanners[0])
                return;
            }
        }
    }, [bannerDataList, promo, contest, productName])

    useEffect(() => {
        account.setInHomepage(true);
        return () => {
            account.setInHomepage(false);
        };
    }, [account]);

    useEffect(() => {
        if(!(isLoading("INIT"))){
            addLoading("INIT")
        }
        if (loggedIn && !!authData.productId) { //logged in and has subscription
                setHasSubscription(!!authData.productId);
                ProductsService.getProductReferenceStandalone({
                    productId: authData.productId,
                    pricePoint: authData.pricePointHandle,
                })
                    .then((res) => {
                        setProductName(res.data.displayName);
                        setFreeProduct(res.data.displayName === "Lite");
                        setPackageData([...res.data.upgrades, ...res.data.downgrades.filter(downgrade => downgrade.displayName !== "Lite")]);
                        setAvod(res.data.upgrades.length > 0);
                    })
                    .catch(()=>{

                    })
                    .finally(()=>{
                        removeLoading("INIT")
                    })
        } else {
            if(!!authData.error && authData.error === 303){
                setGenericError(true)
            }

            if(loggedIn !== undefined){
                ProductsService.getProductsStandalone()
                    .then((response) => {
                        setPackageData(response.data.packages);
                    })
                    .catch(()=>{

                    })
                    .finally(()=>{
                        removeLoading("INIT")
                    })
            }
        }
    }, [loggedIn]); //eslint-disable-line react-hooks/exhaustive-deps

    const productsRef = useRef();

    useEffect(()=>{

    }, [bannerData])
    return (<>
            {(isLoading() || (!(bannerData && !!bannerData.title) && !contextLanding.error)) ? (<Loader/>) : (
                <div className="homepage">
                    {!!bannerData.title ?
                        <Banner
                            avod={avod}
                            hasSubscription={hasSubscription}
                            freeProduct={freeProduct}
                            data-scroll-id="section-1"
                            productsRef={productsRef}
                            productName={productName}
                            goToProducts={goToProducts}
                            upgrades={packageData}
                            bannerData={bannerData}
                            isContest={bannerData.__component === "ant1.contest-banner"}
                        />:
                        <>
                            <div id="banner" style={{
                                backgroundImage: `url("/images/banner/welcome_page4039x2273_v11_blue_70b7b8edb9.jpg")`
                            }}>
                            </div>
                        </>
                    }
                    {!(bannerData.__component === "ant1.contest-banner") &&
                        <>
                            <Preview/>

                            <ProductTabs/>

                            {(!!packageData?.length && !contextLanding.error) &&
                                <div ref={productsRef}>
                                    <ProductCards products={packageData} data-scroll-id="section-2"/>
                                </div>
                            }

                            <Boxes />

                            <Devices/>

                            <UsualQuestions/>
                        </>
                    }

                    <PopUp
                        openPopUp={showInformationModal}
                        setOpenPopUp={setShowInformationModal}
                        maxWidth="md"
                        showCloseButton={true}
                        outlined={false}
                        error={false}
                        closeWhenClickedOutside={true}
                    >
                        <GenericError
                            setClose={setShowInformationModal}
                            success={true}
                            mainText={informationModal[0]?.title}
                            buttonText={informationModal[0]?.buttonText}
                            showIcon={false}
                            executeFunction={() => window.open(informationModal[0]?.redirectURL, "_self")}>
                            <span className={"account-email-popup-secondary-first landing-informationmodal"} ><Markdown>{informationModal[0]?.description}</Markdown></span>
                        </GenericError>
                    </PopUp>
                    <PopUp
                        openPopUp={genericError}
                        setOpenPopUp={setGenericError}
                        maxWidth="md"
                        showCloseButton={true}
                        outlined={false}
                        error={false}
                        closeWhenClickedOutside={false}
                    >
                        <GenericError
                            setClose={setGenericError}
                            success={true}
                            mainText={t("subServiceErrorPopupTitle")}
                            showIcon={false}
                            buttonText={t("subServiceErrorCTA")}
                            executeFunction={()=>{navigate(0)}}
                        >
                            {t("subServiceErrorLanding")}
                        </GenericError>
                    </PopUp>
                </div>)}
        </>);
}

export default Homepage;
